import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { styled, useTheme } from "@material-ui/styles";
// component, hooks
// store
// config,utils

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  // width: "460px",
  maxWidth: "460px",
  minHeight: "161px",
  padding: "40px 56px",
  borderRadius: "16px",
  boxShadow: "0 16px 30px 0 rgba(180, 189, 207, 0.3)",
  backgroundColor: "#fff",
  cursor: "pointer",
  "&:hover": {
    cursor: "pointer",
    boxShadow: "0 16px 50px 0 rgba(180, 189, 207, 0.3)",
  },
}));

const HomeCard = ({ title, content, imgSrc }) => {
  // props

  // route,intl
  // store

  // local state
  // hooks是 null
  // fixme: theme
  const theme = useTheme();

  return (
    <StyledBox>
      <Grid container justifyContent="center" spacing={10}>
        <Grid item container justifyContent="center" alignItems="center" sm={2}>
          <Grid item>
            <Avatar src={imgSrc} sx={{ width: 64, height: 64 }} />
          </Grid>
        </Grid>
        <Grid
          item
          container
          justifyContent="flex-start"
          alignItems="center"
          sx={{
            width: "244px",
          }}
        >
          <Box mb={2}>
            <Typography variant="h6" textAlign="left">
              {title}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" textAlign="left">
              {content}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
HomeCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  imgSrc: PropTypes.string,
};

HomeCard.defaultProps = {
  title: "",
  content: "",
  imgSrc: "",
};

export default HomeCard;
